import React from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import AppMenu from '../components/AppMenu';
import AppFooter from '../components/AppFooter';
import PageMeta from '../components/PageMeta';

export default function ThanksPage() {
  const { state } = useLocation();
  const caseNumber = state && typeof state.caseNumber === 'number' ? state.caseNumber : null;

  return (
    <div className="kh-offer-shell kh-static-page flex flex-col">
      <PageMeta title="Tack för din förfrågan | Klart Hemma" noindex />
      <AppMenu />
      <main className="kh-static-main kh-thanks-main flex-1">
        <div className="kh-static-inner kh-thanks-inner">
          <span className="kh-thanks-mark" aria-hidden="true"><Check className="h-6 w-6" /></span>
          <h1>Tack för din förfrågan</h1>
          <div className="kh-static-content">
            <p>Vi har tagit emot dina uppgifter och hör av oss för att stämma av prisindikationen och nästa steg.</p>
            {caseNumber != null && <p className="kh-thanks-case">Ärendenummer <strong>#{caseNumber}</strong>. Ange det om du kontaktar oss.</p>}
            <p>Frågor under tiden? Ring <a href="tel:+46707388602">0707 388 602</a> eller mejla <a href="mailto:kontakt@klarthemma.com">kontakt@klarthemma.com</a>.</p>
            <div className="kh-thanks-actions">
              <a className="kh-button" href="https://klarthemma.com">Till klarthemma.com <ArrowRight className="h-4 w-4" aria-hidden="true" /></a>
              <a className="kh-text-link" href="/">Ny prisindikation</a>
            </div>
          </div>
        </div>
      </main>
      <AppFooter />
    </div>
  );
}
